export default __webpack_public_path__ + "static/media/ABM Circulos y Asociaciones.73f095e7.xlsx";